import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  // OAuthProvider,       // for Microsoft — uncomment when adding Microsoft sign-in
  // FacebookAuthProvider, // for Facebook — uncomment when adding Facebook sign-in
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from 'firebase/auth';
import { auth } from '../firebase';
import { getUserProfile } from '../services/firebase/users';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      setLoading(true);
      setUser(firebaseUser);
      if (firebaseUser) {
        const p = await getUserProfile(firebaseUser.uid);
        setProfile(p);
      } else {
        setProfile(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  async function signInWithGoogle() {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(auth, provider);
  }

  // async function signInWithMicrosoft() {
  //   const provider = new OAuthProvider('microsoft.com');
  //   await signInWithPopup(auth, provider);
  // }

  // async function signInWithFacebook() {
  //   const provider = new FacebookAuthProvider();
  //   await signInWithPopup(auth, provider);
  // }

  async function signUpWithEmail(email, password) {
    await createUserWithEmailAndPassword(auth, email, password);
  }

  async function signInWithEmail(email, password) {
    await signInWithEmailAndPassword(auth, email, password);
  }

  async function sendPasswordReset(email) {
    await sendPasswordResetEmail(auth, email);
  }

  async function logout() {
    await signOut(auth);
  }

  async function refreshProfile() {
    if (user) {
      const p = await getUserProfile(user.uid);
      setProfile(p);
    }
  }

  // true when the user has an active subscription that hasn't expired
  const isPremium = useMemo(() => {
    const sub = profile?.subscription;
    if (!sub || sub.status !== 'active') return false;
    if (sub.expiresAt) {
      const exp = sub.expiresAt?.toDate ? sub.expiresAt.toDate() : new Date(sub.expiresAt);
      if (exp < new Date()) return false;
    }
    return true;
  }, [profile]);

  return (
    <AuthContext.Provider
      value={{ user, profile, loading, signInWithGoogle, signUpWithEmail, signInWithEmail, sendPasswordReset, logout, refreshProfile, isPremium }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
